import Allergies from './Allergies'
import Medications from './Medications'
import Radiology from './Radiology'
import Documents from './Documents'
import HealthConditions from './HealthConditions'
import Immunizations from './Immunizations'
import TestResults from './TestResults'
import Microbiology from './Microbiology'

import {
  TEST_RESULTS,
  MEDICATIONS,
  IMMUNIZATION,
  ALLERGY,
  HEALTH_CONDITIONS,
  RADIOLOGY,
  MEDICAL_DOCUMENTS,
  MICROBIOLOGY
} from '@web/containers/MyHealth/items.ehr'

const meta = {
  [TEST_RESULTS]: TestResults,
  [MEDICATIONS]: Medications,
  [IMMUNIZATION]: Immunizations,
  [ALLERGY]: Allergies,
  [HEALTH_CONDITIONS]: HealthConditions,
  [RADIOLOGY]: Radiology,
  [MEDICAL_DOCUMENTS]: Documents,
  [MICROBIOLOGY]: Microbiology
}

export default meta
